import type { FieldErrors } from 'react-hook-form';

// Flattens a react-hook-form `errors` map to a comma-separated list of dotted
// field paths (e.g. "purchaser.email, participants.0.fullName"). Used as the
// payload for FORM_VALIDATION_ERROR so downstream analytics rules can see
// which fields failed without exposing user input.
export const summarizeFormErrors = (errors: FieldErrors): string => {
  const paths: string[] = [];

  const walk = (node: unknown, path: string) => {
    if (node == null) {
      return;
    }
    if (Array.isArray(node)) {
      node.forEach((child, i) =>
        walk(child, path ? `${path}.${i}` : String(i)),
      );
      return;
    }
    if (typeof node === 'object') {
      const obj = node as Record<string, unknown>;
      if ('type' in obj && 'message' in obj && typeof obj.type === 'string') {
        if (path) {
          paths.push(path);
        }
        return;
      }
      Object.entries(obj).forEach(([key, value]) => {
        walk(value, path ? `${path}.${key}` : key);
      });
    }
  };

  walk(errors, '');
  return paths.join(', ');
};
